import { CommonModule } from '@angular/common';
import { Component, Output, Input, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { timeZones } from './time-zone.constants';
import { hours } from './hour.constants';
import { minutes } from './minute.constants';
import { WeekdaySchedule } from '@mode/shared/schedules/contract';

export interface SelectedTime {
  displayName: string;
  displayValue: string;
  value: number;
}

@Component({
  selector: 'mode-weekday-schedule-selector',
  standalone: true,
  imports: [CommonModule, MatLegacySelectModule],
  templateUrl: './weekday-schedule-selector.component.html',
  styleUrls: ['./weekday-schedule-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeekdayScheduleSelectorComponent implements OnChanges {
  @Input() weekdaySchedule: WeekdaySchedule = {
    hour: 0,
    minute: 0,
    timeZone: 'UTC',
    frequency: 'weekday',
  };
  @Output() timeChanged = new EventEmitter<WeekdaySchedule>();

  public timeZones = timeZones;
  public hours = hours;
  public minutes = minutes;

  public selectedHour: SelectedTime = { displayName: '', displayValue: '', value: 0 };
  public selectedMinute: SelectedTime = { displayName: '', displayValue: '', value: 0 };
  public selectedTimeZone = '';

  ngOnChanges(): void {
    this.selectedHour = <SelectedTime>this.hours.find((x) => x.value === this.weekdaySchedule.hour);
    this.selectedMinute = <SelectedTime>this.minutes.find((x) => x.value === this.weekdaySchedule.minute);
    this.selectedTimeZone = this.weekdaySchedule.timeZone;
  }

  public onTimeChanged() {
    this.timeChanged.emit({
      frequency: 'weekday',
      hour: this.selectedHour.value,
      minute: this.selectedMinute.value,
      timeZone: this.selectedTimeZone,
    });
  }
}
